/**
 * Interface that can be implement dynamically
 *
 * A `TraitBehavior` is like a TypeScript interface, but can be implemented dynamically.
 * It requires the implementors to implement `TIn` .
 * Also, it can provide do a transform from `TIn` to `TOut` as common logic of the trait.
 */
export class TraitBehavior {
    /** @internal */
    // eslint-disable-next-line no-useless-constructor
    constructor(ownerSpace, trans) {
        this.ownerSpace = ownerSpace;
        this._$trans = trans;
    }
    /** @internal */
    _$implement(impl) {
        var _a;
        return ((_a = this._$trans) === null || _a === void 0 ? void 0 : _a.call(this, impl)) || impl;
    }
}
/**
 * A manager that can implement multiple different trait behaviors
 */
export class TraitGroup {
    constructor() {
        this._$traits = new WeakMap();
    }
    implement(traitBehavior, impl) {
        const traitImpl = traitBehavior._$implement(impl);
        this._$traits.set(traitBehavior, traitImpl);
    }
    get(traitBehavior) {
        return this._$traits.get(traitBehavior);
    }
}
//# sourceMappingURL=trait_behaviors.js.map